import { getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

/**
 * 使用 NEXT_PUBLIC_FIREBASE_* 环境变量初始化。
 * 浏览器内将 authDomain 设为当前 host，便于与静态托管上的 /__/auth 反代同源（与 h5-hybrid 策略一致）。
 */
function buildRuntimeFirebaseOptions(): FirebaseOptions | null {
    return {
        apiKey: 'AIzaSyB3UxLS4jS5RidW7PWn-awZV6wNN_iMPag',
        authDomain: window.location.host,
        projectId: 'whitelightflickstory',
        storageBucket: 'whitelightflickstory.firebasestorage.app',
        messagingSenderId: '693658610967',
        appId: '1:693658610967:web:c44c6b6dcb3ce4177edb52',
        measurementId: 'G-H14R7R5BKG',
    };
}

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

export function getFirebaseApp(): FirebaseApp | null {
    if (typeof window === 'undefined') {
        return null;
    }
    const runtimeOptions = buildRuntimeFirebaseOptions();
    if (!runtimeOptions) {
        return null;
    }
    if (!app) {
        const existing = getApps();
        app = existing.length > 0 ? (existing[0] as FirebaseApp) : initializeApp(runtimeOptions);
    }
    return app;
}

export function getFirebaseAuth(): Auth | null {
    if (typeof window === 'undefined') {
        return null;
    }
    if (!auth) {
        const firebaseApp = getFirebaseApp();
        auth = firebaseApp ? getAuth(firebaseApp) : null;
    }
    return auth;
}
